export default __webpack_public_path__ + "static/media/todolist.2064f33e.png";